import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

interface MenuItem {
  icon: string;
  label: string;
  route: string;
  badge?: number;
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatListModule,
    MatIconModule,
    MatDividerModule
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  menuItems: MenuItem[] = [
    { icon: 'dashboard', label: 'Дашборд', route: '/dashboard' },
    { icon: 'local_parking', label: 'Паркінги', route: '/parking-malls' },
    { icon: 'directions_car', label: 'Сесії паркування', route: '/sessions' },
    { icon: 'timeline', label: 'Трафік', route: '/traffic' },
    { icon: 'pin_drop', label: 'Заповненість', route: '/occupancy' },
    { icon: 'photo_camera', label: 'Фотофіксація', route: '/photo-log' }
  ];
}
